import React from 'react';
import Img3 from './img3';

class SurfImageList extends React.Component{
    state = {PicLoadingQueue : 0 };

    componentDidMount() {
        this.setState({PicLoadingQueue : 0 },()=>{});
    }
    
    nextPicLoadingStart = () => { 
        if(this.state.PicLoadingQueue)
        {
            if (this.state.PicLoadingQueue<this.props.BookVersionListData.length)
            {
                this.setState({PicLoadingQueue : this.state.PicLoadingQueue + 1},()=>{})
            }
        }
        else
        {
            this.setState({PicLoadingQueue : 1 },()=>{}) 
        }
    }

    render (){
        return (
            [
                <div style={{width: "100%",height: "auto", backgroundColor:"transparent",float:"right",padding:"3px",textAlign:"center"}}>
                    {
                        this.props.BookVersionListData.map((BookVersionData,i) =>{
                            return  (
                                [
                                    <a style={{padding:"10px"}} href={"#Page"+(i+1)} onclick="return false;">{i+1}</a>
                                    ,
                                    ((i+1)%15===0)
                                    ?
                                    <br />
                                    :
                                    null
                                ]
                            )
                        })                               
                    }
                </div>
                ,
                <div id="pdf_window">
                    <div id="pdf_window_content">
                    {
                        this.props.BookVersionListData.map((BookVersionData,i) =>{
                            return  (
                                [
                                    <Img3 key={"a"+i+""} 
                                        Class="book_img"
                                        ImageCode={BookVersionData.Code}
                                        PicTurn = {i}
                                        PicLoadingQueue = {this.state.PicLoadingQueue}
                                        nextPicLoadingStart={this.nextPicLoadingStart}
                                    />
                                ]
                            )
                        })
                    }
                    </div>       
                </div>
            ]
        ) 
    }
}

export default SurfImageList;